export const CAT_CAMPAIGN_EVENT_PAGE = 'cats'
